
import React, { useState, useEffect } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';

const AdminModal = ({ isOpen, onClose }) => {
    const [tableNames, setTableNames] = useState(['partner_payments', 'partner_rewards', 'giveaway_attempts']);
    const [data, setData] = useState({});
    const [activeTable, setActiveTable] = useState('');

    const fetchDataForTable = async (tableName) => {
        try {
            const backendUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
            const adminToken = localStorage.getItem('admin_token');
            const response = await axios.get(`${backendUrl}/api/all/${tableName}`,
                {
                    headers: { Authorization: `Bearer ${adminToken}` },
                });
            setData((prevData) => ({ ...prevData, [tableName]: response.data }));
        } catch (error) {
            console.error(`Failed to fetch data for table ${tableName}`, error);
            toast.error(`Failed to fetch data for table ${tableName}.`);
        }
    };

    useEffect(() => {
        if (isOpen) {
            // Set the first table as active and fetch its data
            if (tableNames.length > 0) {
                const firstTable = tableNames[0];
                setActiveTable(firstTable);
                fetchDataForTable(firstTable);
            }
        }
    }, [isOpen, tableNames]);

    useEffect(() => {
        if (activeTable) {
            fetchDataForTable(activeTable);
        }
    }, [activeTable]);


    const modalStyle = {
        opacity: isOpen ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out, transform 0.3s ease-in-out 0.5s',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: isOpen ? 'translate(-50%, -50%)' : 'translate(-50%, -200%)',
        zIndex: 10000,
        width: '80vw', // Adjust width as needed
        height: '80vh', // Adjust height as needed
        overflow: 'hidden'
    };


    return (
        <div className="sync-info-modal" style={modalStyle}>
            <div className="sync-info-modal-header">
                <div className="sync-info-logo1"></div>
                <div className="sync-info-logo2"></div>
                <div className="sync-info-modal-close" onClick={onClose}></div>
            </div>
            <div className="sync-info-modal-content" onClick={(e) => e.stopPropagation()} style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <div style={{ padding: '20px', display: 'flex', flexGrow: 1, overflow: 'hidden' }}>
                    <div style={{ width: '25%', paddingRight: '20px', overflowY: 'auto' }}>
                        <h2 style={{ color: 'white' }}>Tables</h2>
                        <ul style={{ listStyle: 'none', padding: 0 }}>
                            {tableNames.map((tableName) => (
                                <li key={tableName} onClick={() => setActiveTable(tableName)} style={{ cursor: 'pointer', padding: '10px', color: activeTable === tableName ? '#3498db' : 'white', backgroundColor: activeTable === tableName ? '#2c3e50' : 'transparent' }}>
                                    {tableName}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div style={{ width: '75%', overflowY: 'auto' }}>
                        {activeTable && data[activeTable] ? (
                            <div>
                                <h2 style={{ color: 'white' }}>{activeTable}</h2>
                                <div style={{ overflowX: 'auto' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse', color: 'white' }}>
                                        <thead>
                                            <tr style={{ backgroundColor: '#2c3e50' }}>
                                                {data[activeTable].length > 0 && Object.keys(data[activeTable][0]).map((key) => (
                                                    <th key={key} style={{ border: '1px solid #34495e', padding: '8px', textAlign: 'left' }}>{key}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data[activeTable].map((row, index) => (
                                                <tr key={row.id || index} style={{ backgroundColor: index % 2 === 0 ? '#34495e' : '#2c3e50' }}>
                                                    {Object.values(row).map((value, i) => (
                                                        <td key={i} style={{ border: '1px solid #34495e', padding: '8px' }}>{String(value)}</td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ) : (
                            <div style={{ color: 'white' }}>Please select a table to view its content.</div>
                        )}
                    </div>
                </div>
                <div style={{ padding: '20px', textAlign: 'right' }}>
                    <button onClick={onClose} className="common-but">Close</button>
                    <button className="common-but">Save</button>
                </div>
            </div>
        </div>
    );
};

export default AdminModal;
